<template>
	<div class="container">
		<header class="d-flex justify-content-center py-3">
			<ul class="nav nav-pills">
				<router-link custom :to="{path: '/admin'}" v-slot="{href, route, navigate, isActive, isExactActive}">
					<li class="nav-item">
						<a :href="href" @click="navigate" :class="['nav-link', {'active': isExactActive}]">Главная</a>
					</li>
				</router-link>
				<router-link custom :to="{path: '/admin/news'}" v-slot="{href, route, navigate, isActive, isExactActive}">
					<li class="nav-item">
						<a :href="href" @click="navigate" :class="['nav-link', {'active': isExactActive}]">Новости</a>
					</li>
				</router-link>
				<router-link custom :to="{path: '/admin/products-categories'}" v-slot="{href, route, navigate, isActive, isExactActive}">
					<li class="nav-item">
						<a :href="href" @click="navigate" :class="['nav-link', {'active': isExactActive}]">Категории товаров</a>
					</li>
				</router-link>
				<router-link custom :to="{path: '/admin/products'}" v-slot="{href, route, navigate, isActive, isExactActive}">
					<li class="nav-item">
						<a :href="href" @click="navigate" :class="['nav-link', {'active': isExactActive}]">Товары</a>
					</li>
				</router-link>
				<router-link custom :to="{path: '/admin/coupons'}" v-slot="{href, route, navigate, isActive, isExactActive}">
					<li class="nav-item">
						<a :href="href" @click="navigate" :class="['nav-link', {'active': isExactActive}]">Купоны</a>
					</li>
				</router-link>
				<router-link custom :to="{path: '/admin/users'}" v-slot="{href, route, navigate, isActive, isExactActive}">
					<li class="nav-item">
						<a :href="href" @click="navigate" :class="['nav-link', {'active': isExactActive}]">Пользователи</a>
					</li>
				</router-link>
			</ul>
		</header>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	methods: {},
}
</script>